import { Box, Button, Container, Typography } from "@helo/ui";
import NextLink from "next/link";

import NotFoundIllustration from "~/images/shipment-not-found.png";

const NotFound = () => (
  <Container className="section" component="section">
    <Box sx={{ textAlign: "center", pb: "50px", margin: "auto" }}>
      <img
        src={NotFoundIllustration.src}
        alt="Not Found"
        style={{ width: "135px", height: "auto" }}
      />
      <Typography
        variant="h2"
        component="h1"
        sx={({ palette }) => ({
          mb: 1,
          color: palette.secondary.main,
          fontWeight: 600,
        })}
      >
        We could not find your shipment.
      </Typography>
      <Typography variant="body1">
        The tracking number you have entered is invalid or does not exist in our
        system.
      </Typography>
      <NextLink href="/" passHref>
        <Button variant="contained" color="primary" sx={{ mt: 2 }}>
          Try Again
        </Button>
      </NextLink>
    </Box>
  </Container>
);

export default NotFound;
